<div class="container-fuid w-100 header-general d-flex align-items-center fixed-top"> 
    <div class="w-100 align-items-center mx-auto p-0 row row-cols-12">
        <div class="col-0 col-sm-0 col-md-1 col-lg-2 col-xl-3"></div>
        <div class="p-0 py-2 col-6 col-sm-6 col-md-5 col-lg-4 col-xl-3 text-start align-items-center">
            <img class="ms-2 ms-md-0" src="{{whiteLabelProvider.LogoImageSrc}}" alt="Logo"
                *ngIf="whiteLabelProvider.LogoImageSrc">
        </div>
        <div class="p-0 py-2 col-6 col-sm-6 col-md-5 col-lg-5 col-xl-3 align-items-center">
            <div class="header-font text-end me-2 me-md-0">
                <span class="w-100 d-none d-sm-inline me-4 header-font">{{requestName}}</span>
                <span class="d-inline float-end">
                    <div class="dropdown">
                        <a class="dropdown-toggle header-font text-decoration-none" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <span class="fw-normal">{{ currentLanguage.toUpperCase() }}</span>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end mt-2">
                            <li *ngFor="let lang of getLanguages()"><a class="dropdown-item"
                                    (click)="setLanguage(lang)">{{lang.toUpperCase()}}</a></li>
                        </ul>
                    </div>
                </span>
            </div>
        </div>
        <div class="col-0 col-sm-0 col-md-1 col-lg-1 col-xl-3"></div>
    </div>
</div>

<ng-container *ngIf="displaySubHeaderBar">
    <nav aria-label="subnavbar" class="performaction-sub-navbar navbar-inverse navbar-light fixed-top"
        id="performaction-sub-navbar">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 offset-12">
            <app-viewer-sub-header [scrollPosition]="oldScrollPosition"
                (startNextAction)="startActions()"></app-viewer-sub-header>
        </div>
    </nav>
</ng-container>